import { Space } from 'antd';
import TicketInfo from './TicketInfo';
import TicketDTO from '../models/ticket';
import CouponDTO from '../types/Coupon';

interface NumeratedTicketsEntryProps {
  tickets: TicketDTO[],
  coupon?: CouponDTO,
}

const NumeratedTicketsEntry = ({ tickets, coupon }: NumeratedTicketsEntryProps) => (
    <Space size={16} direction='vertical' style={{ width: '100%' }}>
        <div className='text-center p-2 glass-surface'>
            <div className='text-lg font-medium text-text-primary'>Rango de precios</div>
        </div>
        <Space size={16} direction='vertical' style={{ width: '100%' }}>
            {tickets.map((ticket, index) => (
                <TicketInfo key={index} color={ticket.event_sector?.color ?? ''} title={ticket.event_sector?.name ?? ''} description={ticket.description} price={ticket.price} coupon={coupon} />
            ))}
        </Space>
    </Space>
);

export default NumeratedTicketsEntry;
